<template>
    <div class="content-root">
        <cart-nav :options="[ $t('cart_nav.choose_plan'), $t('cart_nav.confirm_details'), $t('cart_nav.complete') ]" :active="cartIndex"></cart-nav>
        <processing v-if="!showCom" :full-screen='true'></processing>
        <div class="switch-container" v-else>
            <component
                :is="mode === ESubscribeMode.SWITCH ? 'switch-success' : 'free-plan-success'"
                :message="mode === ESubscribeMode.SWITCH? message: undefined"
                :refund-tip="refundTip"
                :mode="mode === ESubscribeMode.SWITCH? undefined : mode "
                :planType="planType"
            >
                <template v-slot:associated-failed>
                    <associated-failed
                        :associateFailedString="associateFailedString"
                        :unassociateFailedString="unassociateFailedString"
                    ></associated-failed>
                </template>
            </component>
            <div class="button-box">
                <div class="button-box-inner" v-if="config.platform === 'web'">
                    <template v-if="steps[0] === 'end'">
                        <!-- 如果是云存储套餐 -->
                        <template v-if='isStoragePlan'>
                            <!-- 如果绑定了设备，则显示library按钮 -->
                            <template v-if='dataObj?.associations?.length > 0'>
                                <reo-common-button
                                    :colorType="ECommonButtonType.LIGHT"
                                    :label="$t('cart.finish')"
                                    @click="handleClickLibrary"
                                    :customWidth="finishCustomWidth"
                                />
                            </template>
                            <!-- 否则显示need to bind device按钮 -->
                            <template v-else>
                                <div @click="handleNeedToBindDevice">
                                    <reo-common-button
                                        :to="`${dashBoardLink}&planId=${planId}`"
                                        :label="$t('cart.finish')"
                                        :customWidth="finishCustomWidth"
                                    />
                                </div>
                            </template>
                        </template>
                        <!-- 否则只显示dashboard按钮 -->
                        <template v-else>
                            <reo-common-button
                                :to="dashBoardLink"
                                :label="$t('cart.finish')"
                                :customWidth="finishCustomWidth"
                            />
                        </template>
                    </template>
                    <reo-common-button
                        v-if="steps.length > 1"
                        color-type="dark"
                        customWidth='100%'
                        :label="$t('pagination.next')"
                        @click="nextStep"
                    ></reo-common-button>
                </div>
            </div>
            <div class="button-box" v-if="config.platform === 'app' ">
                <div class="button-box-inner">
                    <reo-common-button
                        color-type="dark"
                        customWidth='100%'
                        :label="$t('cart.finish')"
                        @click="handleButtonClick('app')"
                    ></reo-common-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import processing from '@/basic/processing.vue';
import ReoCommonButton from '@/components/ReoCommonButton.vue';
import { getSubscriptionById } from '@/api/subscriptions';
import { timeResolve } from '@/common/js/date';
import { config } from 'CONFIG';
import { unfoldError } from '@/common/js/notice';
import { listToString } from '@/api/s3Config';
import { deliver as deliverStatus, currStage as currentStage } from '@/config/status';
import cartNav from '@/components/cartNav.vue';
import reolinkGa from '@/common/js/gtagPageview';
import nprogress from 'nprogress';
import { getOrderDetailById, getPlanById } from '@/api/cart';
import { unitTransfer } from '@/common/js/utils';
import router from '@/router';
import store from '@/store';
import { AxiosError } from 'axios';
import { productsManager, uidHandler } from '@/lib';
import { EAccountDeviceStatus, ECommonButtonType, EDeviceInfoModule, ESeriesCategory, ESubscribeMode, IOrder, IPlan, TCloudDevice } from '@reolink-cloud/interface';
import { getDeviceList } from '@/api/device';
import { handleDeviceTitle } from '@/components/lib';
import AssociatedFailed from '@/components/AssociatedFailed.vue';
import FreePlanSuccess from './FreePlanSuccess.vue';
import SwitchSuccess from './SwitchSuccess.vue';
import { requestToApp } from '@/api/app';
import { callAppApi } from '@reolink-web/app-sdk';
import { isApp, doorbellProgressStorage } from '@/utils/business';
import { completePendingSubscription } from '@/utils/app';
import { Async } from '@reolink-web/utils';
import { mapGetters } from 'vuex';

export default Vue.extend({

    components: {

        cartNav,
        ReoCommonButton,
        processing,
        AssociatedFailed,
        FreePlanSuccess,
        SwitchSuccess

    },
    data () {

        return {

            config,

            ESubscribeMode,

            dataObj: {} as Record<string, any>,
            cloudProductLists: {} as Record<string, any>,
            freeTip: '',
            refundTip: this.$route.query.refund,
            cartIndex: 2,
            showCom: false,
            mode: this.$route.query.mode as string,
            subId: this.$route.query.id as string,
            associateFailedString: '',
            unassociateFailedString: '',
            deviceList: [] as any[],
            timer: null as null | number,
            e2eeEnabled: true,
            steps: [] as any[],
            planType: ESeriesCategory.CLOUD_STORAGE_PLAN,
            planId: '',
            subscriptionId: '',
            planInfo: {} as IPlan,
            ECommonButtonType,
        };

    },

    async created () {

        try {

            // 开启 E2EE FEATURE
            if ( !this.FEATURE( 'main.e2ee' )) {

                await store.dispatch( 'getCMKS' );
                this.e2eeEnabled = Boolean( store.getters.enforcedCMK );

            }
            this.steps.push( 'end' );
            await productsManager.update({ lang: this.lang });

            await this.getDeviceList();

            let order = {} as IOrder;
            await new Promise(( resolve, reject ) => {

                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                this.timer = window.setInterval( async (): Promise<void> => {

                    try {

                        order = await getOrderDetailById( this.subId );
                        this.planType = order.items[0].productType;
                        this.planId = order.items[0].productId;
                        this.subscriptionId = order.items[0].context.subscription ?? '';

                        if ( !( order.status.currStage === currentStage.DELIVER && order.status.deliverStatus === deliverStatus.PENDING )) {

                            window.clearInterval( this.timer! );
                            resolve( true );

                        }

                    } catch ( err ) {

                        reject( err );

                    }

                }, 5000 );

            });
            try {

                if ( !order.items[0].context.trackingInfo?.[0].shippedProduct.serviceId ) {

                    unfoldError( 'errors.server_error', 100000 );
                    return;

                }
                let sub = await getSubscriptionById( order.items[0].context.trackingInfo?.[0].shippedProduct.serviceId );
                this.dataObj = sub;
                this.dataObj.startedTime = sub.startedAt;
                this.dataObj.expiredTime = sub.endingAt;

                let planInfo = await productsManager.getPlanById( order.items[0].productId );

                this.dataObj.unit = planInfo.duration.unit;
                this.dataObj.frequency = planInfo.duration.amount;
                this.freeTip = planInfo.pricing.salePrice;
                this.planInfo = planInfo;

                this.showCom = true;

                await this.handleGAEvent( order );

            } catch ( err ) {

                console.log( err );

            }

            this.handleAssociatedDevices( order );
            if ( isApp && this.planType == ESeriesCategory.CLOUD_DATA_PLAN ) {

                Async.invokeAsync(

                    () => callAppApi( 'simCardActivated' )
                );

            }
            nprogress.done();

        } catch ( err ) {

            unfoldError( 'errors.server_error', 10000 );
            console.log( err );
            let symbol = ( err as AxiosError ).response?.data.error.symbol;
            if ( symbol === 'order_not_found' ) {

                router.push( '/user/cloud-plan-payment-history/' ).catch( console.error );

            }

        }

    },

    methods: {
        async handleButtonClick( loc: string ): Promise<void> {

            if ( loc === 'library' ) {

                await router.push( '/user/cloud-library/'  );

            } else if ( loc === 'dashboard' ) {

                await router.push( `/user/dashboard/?tab=${[ESeriesCategory.CLOUD_STORAGE_PLAN, ESeriesCategory.CLOUD_RICH_NOTIFICATION_PLAN].includes( this.planType ) ? 'cloud' : 'sim'}` );

            } else if ( loc === 'e2ee' ) {

                const e2ee_link = `${config.accountCenterProfileUrl}?open=totp&current=security`;
                window.open( e2ee_link, '_blank' );

            } else if ( loc === 'app' ) {

                completePendingSubscription( this.subscriptionId );
                await callAppApi( 'finishPage', { planId: this.planId, subscriptionId: this.subscriptionId });

            } else {
                /** empty */
            }

        },

        async getDeviceList () {

            const accountDevicesRes = await getDeviceList({
                statuses: [
                    EAccountDeviceStatus.BOUND,
                    EAccountDeviceStatus.UNBOUND
                ],
                includes: [
                    EDeviceInfoModule.ONLINE_CONFIG,
                    EDeviceInfoModule.CONFIG_TEMPLATE,
                    EDeviceInfoModule.MODEL,
                    EDeviceInfoModule.CHANNELS
                ]
            });

            const deviceList = accountDevicesRes.items as TCloudDevice[];
            for ( let device of deviceList ) {

                device.title = handleDeviceTitle( device );

            }

            this.deviceList = deviceList;

        },

        handleAssociatedDevices( order: IOrder ): void {

            let associateDevices = order.items[0].context?.associateDevices ?? [];
            let unassociateDevices = order.items[0].context?.unassociateDevices ?? [];
            let associateFailed: any[] = [];
            let unassociateFailed: any[] = [];

            for ( let item of associateDevices ) {

                let uid = item.uid;
                let status = item.status;
                if ( status === 'unassociated' ) {

                    Object.keys( this.deviceList ).map( key => {

                        if ( this.deviceList[key].uid === uid ) {

                            associateFailed.push({
                                uid: uid,
                                title: this.deviceList[key].title || this.deviceList[key].modelTitle
                            });

                        }

                    });

                }

            }

            for ( let item of unassociateDevices ) {

                let uid = item.uid;
                let status = item.status;
                if ( status === 'associated' ) {

                    Object.keys( this.deviceList ).map( key => {

                        if ( this.deviceList[key].uid === uid ) {

                            unassociateFailed.push({
                                uid: uid,
                                title: this.deviceList[key].title || this.deviceList[key].modelTitle
                            });

                        }

                    });

                }

            }

            this.associateFailedString = listToString( associateFailed.map( item => ( this.$t( 'order_complete.deviceString', { nickName: item.title, uid: item.uid }) as string )), this.$store.state.lang.lang );
            this.unassociateFailedString = listToString( unassociateFailed.map( item => ( this.$t( 'order_complete.deviceString', { nickName: item.title, uid: item.uid }) as string )), this.$store.state.lang.lang );
            const inDoorbellProgress = this.$route.query.inDoorbellProgress;
            if ( typeof inDoorbellProgress === 'string' ) {

                const uid = uidHandler.decrypt( inDoorbellProgress );
                if ( !associateFailed.some( item => item.uid === uid )) {

                    requestToApp( 'completeSubscription', undefined );
                    if ( this.planInfo.freeOfferAvailable ) {

                        reolinkGa.sendFreeOfferEvent( 'cloud-reco1-single-60day-plan-complete' );

                    }

                }

            } else {

                const doorbellUid = doorbellProgressStorage.getItem( 'doorbell_progress_uid' ) ?? '';
                if ( doorbellUid ) {

                    if ( !associateFailed.some( item => item.uid === doorbellUid )) {

                        requestToApp( 'completeSubscription', undefined );
                        if ( this.planInfo.freeOfferAvailable ) {

                            reolinkGa.sendFreeOfferEvent( 'cloud-reco1-single-60day-plan-complete' );

                        }

                    }
                    doorbellProgressStorage.removeItem( 'doorbell_progress_uid' );

                }

            }

        },

        async handleGAEvent ( order: IOrder ): Promise<void> {

            reolinkGa.sendSubscribeMode();

            let name: string, itemListName: string;

            let planDetailsInEn: Required<IPlan>;

            if ( this.lang !== 'en' ) {

                planDetailsInEn = ( await getPlanById( order.items[0].productId )).plan as Required<IPlan>;

            } else {

                planDetailsInEn = await productsManager.getPlanById( order.items[0].productId ) as Required<IPlan>;

            }

            name = planDetailsInEn.series?.i18n.name ?? 'unknown';
            itemListName = `(cloud-Plan)storageRegion:${planDetailsInEn.series?.storageRegion};deviceGroup:${planDetailsInEn.series?.deviceGroup}`;
            name += `(${planDetailsInEn.duration.amount}-${planDetailsInEn.duration.unit})`;
            name += `(${planDetailsInEn.style['cloud_storage.video_lifetime'] ?? 'undefined'}-days,${planDetailsInEn.style['cloud_storage.max_device_quantity'] ?? 'undefined'}-cams,${unitTransfer( planDetailsInEn.style['cloud_storage.space_capacity'] ?? 0 )}${unitTransfer( planDetailsInEn.style['cloud_storage.space_capacity'] ?? 0, 'unit' )})`;

            let eventData = {
                currency: order.currency,
                value: 0.00,
                transaction_id: order.id,
                tax: 0.00,
                items: [{
                    item_id: order.items[0].productId,
                    item_name: `(cloud-Plan)${name}`,
                    item_category: 'cloud-Plan',
                    price: 0.00,
                    quantity: 1,
                    item_list_name: itemListName,
                    item_variant: `mode:${this.mode}`
                }]
            };

            reolinkGa.sendECommerceEvent( 'purchase', eventData );

        },

        timeFormat ( time: number ): string {

            let {

                year,
                month,
                dateOfMonth,
                hour

            } = timeResolve( time );

            return `${this.$t( `date_format.default`, {
                year,
                month,
                day: dateOfMonth
            }) as string} ${hour}:00`;

        },

        getHref () {

            return window.location.href;

        },

        nextStep () {

            this.steps.shift();

        },

        async handleClickLibrary(): Promise<void> {

            reolinkGa.sendSimpleEvent( 'Cloud Storage Service-My Cloud Library' );
            await this.$router.push( '/user/cloud-library/' );

        },

        handleNeedToBindDevice(): void {

            reolinkGa.sendSimpleEvent( 'Cloud Storage Service-link device' );

        },

    },

    computed: {
        ...mapGetters( ['isMobile'] as const ),

        message () {

            let title = this.dataObj.title;
            let unit = this.dataObj.unit;
            let frequency = this.dataObj.frequency;
            let startedTime = this.dataObj.startedTime;
            let expiredTime = this.dataObj.expiredTime;
            let result = [
                {
                    label: this.$t( 'switch_plan.plan_name' ),
                    texts: [
                        `${title} (${this.$tc( `cycle.${unit}`, frequency, {

                            count: frequency

                        })})`
                    ],
                    red: true
                },
                {
                    label: this.$t( 'switch_plan.valid_time' ),
                    texts: [

                        `${this.timeFormat( startedTime )}-${this.timeFormat( expiredTime )}`

                    ]
                }
            ];

            if ( this.freeTip === '0.00' ) {

                result[1].texts.push( this.$t( 'switch_plan.free_tip' ) as string );

            }

            return result;

        },

        isStoragePlan(): boolean {

            return this.planType === ESeriesCategory.CLOUD_STORAGE_PLAN;

        },

        dashBoardLink (): string {

            return `/user/dashboard/?tab=${this.isStoragePlan ? 'cloud' : 'sim'}`;

        },

        totp (): boolean {

            return this.$store.state.user.user.totp;

        },

        lang(): string {

            return this.$store.getters.lang;

        },

        isTraffic (): boolean {

            return this.planType === ESeriesCategory.CLOUD_DATA_PLAN;

        },
        finishCustomWidth(): number|string {

            return this.isMobile ? '100%' : 200;

        }

    },
    beforeDestroy () {

        window.clearInterval( this.timer! );

    }

});
</script>

<style lang='less' scoped>
    .content-root {
        color: @font_primary;
        padding: 60px 0 120px;
        @media @snapeak_mobile{
            padding: 0;
        }
        .switch-container{
            margin: auto;
            max-width: 1200px;
            background-color: @bg_02;
            padding: 60px 0 80px;
            @media @snapeak_mobile{
                padding: 60px 20px 60px;
            }
        }
        .button-box {
            margin: auto;
            text-align: center;
            padding-top: 84px;
            @media @snapeak_mobile{
                padding-top: 36px;
            }
            .button-box-inner{
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 16px;
                width: 420px;
                margin: 0 auto;
                @media @snapeak_mobile{
                    width: 100%;
                }
                .totp-button-label{
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 22px;
                }
            }

        }
    }
    .app-platform .content-root{
        height: 100vh;
    }
</style>
